/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'ptc.pm.collaborators.title': 'Ihre Mitarbeiter',
  'ptc.pm.error-heading': 'Fehler',
  'ptc.pm.error-image-alt-text': 'Ein kaputter Roboter und mehrere Personen, die ihn reparieren',
  'ptc.pm.error-text':
    'Wir verfolgen diese Fehler, aber Sie können sich gerne an uns wenden, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} Mitglied} other {{memberCount,number} Mitglieder}}',
  'ptc.pm.people': 'Personen',
  'ptc.pm.teams': 'Teams',
  'ptc.pm.view-your-profile': 'Profil anzeigen',
  'ptc.pm.your-teams.title': 'Ihre Teams',
};
